import React from 'react';
import './nav_but.css'

const Navlink = (props) => {
    return ( 
        <button className={props.stylee}>
                <img src={props.img} alt={props.alt}></img>
                <h2 className={props.stylee2}>{props.title}</h2>
        </button>
     );
}
 
export default Navlink;